// extracted by mini-css-extract-plugin
module.exports = {"buttonGradientLoading":"styles_buttonGradientLoading__22wYc","buttonGradientLoader":"styles_buttonGradientLoader__oEN9W","buttonGradientText":"styles_buttonGradientText__e5KPe"};